export default{
    userInfo: state=>state.User.userInfo,
    token: state=>state.User.token,
    menu: state=>state.Menu.menuList,
    handleMenu: state=>state.Menu.handleMenu,
    menuFirstInfo: state=>state.Menu.menuFirstInfo,
    menuActive: state=>state.Menu.menuActive,
    menuSliderActive: state=>state.Menu.menuSliderActive,
    menuTopList: state=>state.Menu.menuTopList,
}